// extracted by mini-css-extract-plugin
export default {"Spacer16":"style_Spacer16__9BZRv","Spacer24":"style_Spacer24__eQocU","Spacer32":"style_Spacer32__nJ-hi","Spacer40":"style_Spacer40__IRhVE","Spacer65":"style_Spacer65__83bZ2"};